import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useScheduledActionInvoiceQuery } from '../../../../api/gql';
import { ContactInfoBox } from '../../../../modules/admin/invoice/ContactInfoBox';

type Props = {
  taskId: string;
} & PaperProps;

export const TaskIdCustomerInfoBox = ({ taskId, ...rest }: Props) => {
  const { data, isLoading, isError } = useScheduledActionInvoiceQuery({
    id: taskId,
  });
  const { t } = useTranslation();
  const customer = useMemo(() => data?.scheduledAction.invoice.customer, [data?.scheduledAction.invoice.customer]);

  return <ContactInfoBox title={t('customer')} contact={customer} isLoading={isLoading} isError={isError} {...rest} />;
};
